import { jsonBody, requestJson } from "./http/httpClient";
import { readBoolean, readObject } from "./http/jsonDecoding";

const path = "/accounts/users/me/sign-up-notifications";
const decodeResponse = (body: unknown) => readBoolean(readObject(body, "notification preference"), "enabled");

export function readSignUpNotifications(signal?: AbortSignal): Promise<boolean> {
  return requestJson({ method: "GET", path, signal, decodeResponse });
}

export function setSignUpNotifications(enabled: boolean): Promise<boolean> {
  return requestJson({ method: "PUT", path, body: jsonBody({ enabled }), decodeResponse });
}
